export default __webpack_public_path__ + "static/RC_how_we_do_it_icons-01-931945c6551f427f145796b361cc80cc.png";